module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedHeavyItalic.087609c.woff2";